import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import AppConfig from "../../AppConfig";
import {
    ActivityIndicator,
} from "../../custom-packages/react-native-components-in-react/react-native-components-in-react";
import {GetAuthObject} from "../../authentication/AuthFunctions";
import * as AuthActions from "../../store/actions/authActions";

const TFreeTrialScreen = {
    enUS: {
        'ACTIVATING': 'Activating Free Trial',
        'FREE_TRIAL_ACTIVATED': 'Free Trial Activated Successfully',
        'FREE_TRIAL_EXPIRED': 'Your Free Trial Code has expired',
    },
    esMX: {
        'ACTIVATING': 'Activando prueba gratuita',
        'FREE_TRIAL_ACTIVATED': 'Prueba gratuita activada exitosamente',
        'FREE_TRIAL_EXPIRED': 'El código de tu prueba gratuita ha expirado',
    },
};

let activated = false;

const FreeTrialScreen = () => {
    const params = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const Auth = useSelector((state) => state.Auth);
    const [loading, setLoading] = useState(true);
    const [success, setSuccess] = useState(false);

    const code = params.code;

    useEffect(() => {
        const f = async () => {
            const response = await fetch(AppConfig.URL + '/Account/ActivateFreeTrial?code=' + code, {
                method: 'GET',
                headers: {
                    'Authorization': Auth.token,
                    'Content-Type': 'application/json',
                },
            });

            const data = await response.json();

            if(data.success) {
                if(data.user){
                    const newAuth = GetAuthObject(data);

                    dispatch(AuthActions.saveAuth(newAuth))
                }

                navigate('/admin/setup/subscription/result?success=true', { replace: true })

                setSuccess(true)
            }

            setLoading(false)
        }

        if(!activated) {
            activated = true;

            f()
        }
    }, [Auth, code]);

    if(loading) {
        return <div style={{ textAlign: 'center', marginTop: 50 }}>
            <h1  style={{ miarginBottom: 15 }}>
                {TFreeTrialScreen[AppConfig.lang].ACTIVATING}
            </h1>
            <ActivityIndicator />
        </div>;
    }


    return (
        <div style={{ marginTop: 50, fontSize: 22, textAlign: 'center' }}>
            {
                success ?
                    TFreeTrialScreen[AppConfig.lang].FREE_TRIAL_ACTIVATED
                    :
                    TFreeTrialScreen[AppConfig.lang].FREE_TRIAL_EXPIRED
            }
        </div>
    );
};


export default FreeTrialScreen;